var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMtStarBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 280 280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mt-star_border") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#91908d",
    d: "M256.667 107.8l-83.883-7.233-32.783-77.233-32.783 77.35-83.883 7.117 63.7 55.183-19.133 82.017 72.1-43.517 72.1 43.517-19.017-82.017 63.583-55.183zM140 179.667l-43.867 26.483 11.667-49.933-38.733-33.6 51.1-4.433 19.833-47.017 19.95 47.133 51.1 4.433-38.733 33.6 11.667 49.933-43.983-26.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMtStarBorder);
export default __webpack_public_path__ + "static/media/mt-star_border.81c23ab467d562e2d576a5d317c27173.svg";
export { ForwardRef as ReactComponent };